import PageTitle from "@/components/PageTitle";
import BackLink from "@/components/BackLink";
import DashLayout from "@/layouts/DashLayout";
import RoleProtectedPage from "@/layouts/RoleProtectedPage";
import MenuForm from "@/components/menu/MenuForm";
import { useParams } from "react-router-dom";
import { useGetMenuByIdQuery } from "@/redux/services/menu/menu.api";
import { Roles } from "@/redux/services/user/user.type";
import { MENU_EDIT_PERMISSIONS } from "@/lib/navigation";

const EditMenuContent = () => {
  const { id } = useParams();
  const { data: menu, isLoading } = useGetMenuByIdQuery(id as string);

  return (
    <div className="space-y-6">
      <div>
        <BackLink to="/menus" label="Retour aux menus" />
        <PageTitle title="Modifier le menu" description="Modifiez les détails et les sections de votre menu" />
      </div>
      <div className="bg-card rounded-lg border border-border p-6">
        <MenuForm item={menu} isEdit={true} isLoad={isLoading} />
      </div>
    </div>
  );
};

// Saving a menu needs menu.manage on the API (SFRESTO-128): without it the
// editor would only collect 403s.
const EditMenu = () => (
  <DashLayout>
    <RoleProtectedPage
      allowedRoles={[Roles.manager, Roles.owner]}
      allowedPermissions={MENU_EDIT_PERMISSIONS}
    >
      <EditMenuContent />
    </RoleProtectedPage>
  </DashLayout>
);

export default EditMenu;
